<script>
    import HeaderCheckbox from "../../content/common/PrimeVue/HeaderCheckbox.vue";
    import SwitchOffTimesTimepicker from "./switch-off-times-timepicker.vue";
    import toaster from "../../common/toaster";
    import API from "../../../API";
    import Loading from "../../common/loading.vue";
    import SwitchOffTimes from "./switch-off-times.vue";
    import switchOffTimesHelper from "./switchOffTimesHelper"
    import defaultSwitchOffTimes from "../client/defaultSwitchOffTimes";

    export default {
        name: "switch-off-times-view",
        components: {SwitchOffTimes, Loading, SwitchOffTimesTimepicker, HeaderCheckbox},
        props: {
            dataAsString: String,
        },
        data() {
            return {
                data: undefined,
                savingInProgress: false,
                error: false
            }
        },
        computed: {
            translations() {
                return {
                    title: Lang.langGet('Switch-On Times'),
                    success: Lang.langGet("Successfully updated & transmitted Switch-On Times."),
                    failed: Lang.langGet("Failed to update & transmit Switch-On Times."),
                    updateButton: Lang.langGet('Update & Transmit To Clients'),
                }
            }
        },
        methods: {
            handleChange(newData) {
                this.data = newData;
            },
            getSwitchOffTimes() {
                return switchOffTimesHelper.fixCapitalizationOfProperties(this.data);
            },
            async handleSave() {
                this.savingInProgress = true;

                if (this.error) return;

                const url = '/administration/switch-on-times/edit';
                const settings = {dontSnakeCase: true};
                const api = new API(url, settings);

                const data = {
                    id: Laravel.activeProject,
                    switch_off_times: this.getSwitchOffTimes()
                };

                const response = await api.post(data);
                this.savingInProgress = false;

                if (response.errored) {
                    toaster.error(this.translations.failed);
                } else {
                    toaster.success(this.translations.success);
                }
            },
            parseSwitchOffTimes(data = this.dataAsString) {
                if (!data || data === '[]') {
                    return {
                        all: {
                            active: false,
                            from: defaultSwitchOffTimes.startTime,
                            to: defaultSwitchOffTimes.endTime
                        },
                        days: defaultSwitchOffTimes.days
                    };
                }

                const parsedData = JSON.parse(this.dataAsString);

                parsedData.all.from.hh = parsedData.all.from.hh || parsedData.all.from.HH;
                parsedData.all.to.hh = parsedData.all.to.hh || parsedData.all.to.HH;

                const nameOfDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
                nameOfDays.forEach(name => {
                    parsedData.days[name].from.hh = parsedData.days[name].from.hh || parsedData.days[name].from.HH;
                    parsedData.days[name].to.hh = parsedData.days[name].to.hh || parsedData.days[name].to.HH;
                });

                return parsedData;
            }
        },
        mounted() {
            this.data = this.parseSwitchOffTimes();
        }
    }
</script>

<template>
    <div class="switch-off-times">
        <loading :loading="savingInProgress"/>
        <div class="col d-flex flex-row justify-space-between align-center mb-4">
            <h1>{{ translations.title }}</h1>
            <v-btn
                :class="[(error || savingInProgress) ? 'disabled' : '','btn btn-primary']"
                :disabled="savingInProgress"
                @click="handleSave"
            >
                <i class="fa-regular fa-spinner" :class="[savingInProgress ? '' : 'hidden', 'fa-spin-pulse m-r-sm']"/>
                {{ translations.updateButton }}
            </v-btn>
        </div>
        <div style="width: 640px">
            <switch-off-times v-if="data"
                :data="data"
                @input="handleChange"
            />
        </div>
    </div>
</template>
